<template>
  <div :class="componentClassName">
    <div class="m-no-ivr-automatic-voice-guidance__fields">
      <a-switch
        v-model="noIVRGuidanceFlag"
        label="自動音声ガイダンスを設定"
        :disabled="viewOnly"
        @change="updateModelData"
      />
      <template v-if="noIVRGuidanceFlag">
        <m-form-input label="ガイダンス内容">
          <a-text-field
            id="noIVRGuidance"
            v-model="noIVRGuidance"
            type="textarea"
            rows="7"
            placeholder="お電話ありがとうございます。●●株式会社でございます。
この通話はサービス品質向上のため録音させていただきます。"
            :disabled="viewOnly"
            @change="updateModelData"
          />
        </m-form-input>
        <div class="m-no-ivr-automatic-voice-guidance__button">
          <a-button
            v-show="!isVoicePlaying"
            id="play"
            variant="fill"
            color="primary"
            size="small"
            icon="play"
            icon-color="white"
            @click="handleTestButtonClick"
          >
            テスト再生
          </a-button>
          <a-button
            v-show="isVoicePlaying"
            id="stop"
            variant="fill"
            color="primary"
            size="small"
            icon="audio-pause"
            icon-color="white"
            :disabled="!noIVRGuidanceFlag"
            @click="handleTestButtonClick('stop')"
          >
            テスト停止
          </a-button>
        </div>
      </template>
    </div>
    <teleport to="body">
      <o-modal
        id="noIVRGuidanceInfoModal"
        v-model:visible="infoModalVisible"
        class="o-modal-info-modal"
        footer-variant="confirmation"
        width="442px"
        z-index="9999"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ infoModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="infoModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button id="modal-ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 'm-no-ivr-automatic-voice-guidance',
  components: {},
  props: {
    class: {
      type: String,
      default: '',
    },
    setting: {
      type: Object,
      default: null,
    },
    isVoicePlaying: {
      type: Boolean,
      default: false,
    },
    voiceList: {
      type: Array,
      default: new Array(0),
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:noIvrGuidanceSetting', 'play', 'stop'],
  data() {
    return {
      noIVRGuidanceFlag: false,
      noIVRGuidance: '',
      currentVoice: '',

      // modal
      infoModalVisible: false,
      infoModalTitle: '',
      infoModalContent: '',
      uploadModalVisible: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-no-ivr-automatic-voice-guidance', this.responseMode);
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    this.noIVRGuidanceFlag = this.setting.noIVRGuidanceFlag;
    this.noIVRGuidance = this.setting.noIVRGuidance;
  },
  mounted() {
    if (this.voiceList.length > 0 && this.currentVoice === '') {
      this.currentVoice = this.voiceList[0].value || '';
    }
  },
  methods: {
    updateModelData() {
      const data = {
        noIVRGuidanceFlag: this.noIVRGuidanceFlag,
        noIVRGuidance: this.noIVRGuidance,
      };
      this.$emit('update:noIvrGuidanceSetting', data);
    },
    handleTestButtonClick(e) {
      if (e === 'stop') {
        return this.$emit('stop');
      }
      this.$emit('play', {
        voice: this.currentVoice,
        content: this.noIVRGuidance,
      });
      return '';
    },
    showInfoModal(content) {
      this.infoModalTitle = messageContent.infoModalTitle;
      this.infoModalVisible = true;
      this.infoModalContent = content;
    },
    showErrorModal(message) {
      this.infoModalVisible = true;
      this.infoModalTitle = messageContent.errorModalTitle;
      this.infoModalContent = message;
    },
    handleCloseModal() {
      this.infoModalVisible = false;
      this.infoModalTitle = '';
      this.infoModalContent = '';
    },
  },
};
</script>
